import { memo } from "react";

import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";

import RestoreIcon from '@mui/icons-material/Restore';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import Timeline from '../view-dispatches/timeline';

const cardSx = { borderRadius: 3, boxShadow: 3 };

// Local component representing a single dispatch card
export const DispatchCard = memo(
    function DispatchCard({
        dispatch,
        onViewProducts,
        onViewHistory,
        viewButton = true,
        viewHistory = false,
        defaultBorders = false,
    }) {
        return (

            <Card sx={defaultBorders ? "" : cardSx}>

                <MDBox p={3}>
                    {/* Header */}
                    <MDBox display="flex" justifyContent="space-between" mb={3}>
                        <MDBox>
                            <MDTypography variant="h4" fontWeight="bold">
                                {`Dispatch #${dispatch.dispatch_num}`}
                            </MDTypography>
                            <MDTypography variant="h6" color="text.secondary" fontWeight="light">
                                {dispatch.description}
                            </MDTypography>
                            <MDTypography variant="h6" color="text.secondary" fontWeight="light">
                                {dispatch.organization}
                            </MDTypography>
                        </MDBox>

                        {viewHistory && (
                            <MDBox>
                                <Tooltip title="View Change History">
                                    <IconButton
                                        onClick={() => onViewHistory?.(dispatch)}
                                    >
                                        <RestoreIcon />
                                    </IconButton>
                                </Tooltip>
                            </MDBox>
                        )}

                        {viewButton && (
                            <MDBox>
                                <MDButton
                                    variant="outlined"
                                    color="info"
                                    size="small"
                                    onClick={() => onViewProducts?.(dispatch)}
                                >
                                    VIEW DISPATCH’S PRODUCTS
                                </MDButton>
                            </MDBox>
                        )}

                    </MDBox>

                    {dispatch?.status.toLowerCase() === "rejected" ?
                        (
                            <MDBox display="flex" justifyContent="center" alignItems="center" height="50px" width="100%">
                                <MDTypography variant="h6" color="warning" fontWeight="medium" align="center">
                                    This dispatch request has been rejected. Our Team will contact you for more information.
                                </MDTypography>
                            </MDBox>
                        ) :
                        (<Timeline status={dispatch.status} dispatch={dispatch}/>)
                    }

                </MDBox>

            </Card>
        );
    });